// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"t9-z"};